import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=5b638418"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports